/**
 * Created by DynamicDog on 2016-12-03.
 *
 * App module, collects all the components in this app.
 */
import { NgModule }      from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent }  from './app.component';
import { EtikettService } from './services/etikett.service';
import {Location, LocationStrategy, PathLocationStrategy} from '@angular/common';
import {TranslateService} from './services/translate.service';
import {AppHeaderComponent} from "./appheader.component";
import {AppViewComponent} from './app.view.component';
import {IntroViewComponent} from "./intro.view";
import {EtikettModule} from "./etikett/etikett.module";
import {PrintViewComponent} from "./print/print.view";
import {SharedModule} from "./shared.module";
import {AppFooterComponent} from "./appfooter.component";
import {EtikettSpinnerComponent} from "./print/etikettspinner.component";
import {UploadModule} from "./upload/upload.module";
import {NumberSpinnerComponent} from "./print/numberspinner.component";
import {BusyScreenComponent} from "./print/busyscreen";
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {EmailDialogComponent} from "./dialogs/maildialog.component";
import {DialogsService} from "./dialogs/email.service";
import {ModalComponent} from "./print/modal.component";
import {SelectViewComponent} from "./select.view";

@NgModule({
  imports:      [ BrowserModule,EtikettModule, SharedModule,UploadModule,BrowserAnimationsModule],
  declarations: [ AppComponent, AppHeaderComponent, AppViewComponent, AppFooterComponent,IntroViewComponent, SelectViewComponent,PrintViewComponent,EtikettSpinnerComponent, NumberSpinnerComponent,BusyScreenComponent,EmailDialogComponent],
  bootstrap:    [ AppComponent ],
  entryComponents: [EmailDialogComponent],
  providers:    [EtikettService, TranslateService, Location,{ provide: LocationStrategy, useClass: PathLocationStrategy},DialogsService]
})

export class AppModule { }




// WEBPACK FOOTER //
// ./app/app.module.ts